import React from 'react';
import { useTranslation } from '../../i18n/LanguageContext';
import { Shield, Home } from 'lucide-react';

const ConfidentialityPage = () => {
  const { t } = useTranslation();

  return (
    <div style={{
      minHeight: '100vh',
      width: '100%',
      background: 'linear-gradient(180deg, #0a0e27 0%, #1a1f3a 100%)',
      color: '#ffffff',
      fontFamily: '-apple-system, BlinkSystemFont, "SF Pro Display", sans-serif',
      padding: '120px 20px 40px',
      maxWidth: '1200px',
      margin: '0 auto'
    }}>
      <button
        onClick={() => window.location.href = '/'}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          background: 'rgba(255, 255, 255, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          color: '#ffffff',
          padding: '10px 16px',
          borderRadius: '12px',
          fontSize: '14px',
          fontWeight: 600,
          cursor: 'pointer',
          marginBottom: '32px'
        }}
      >
        <Home size={18} />
        Retour à l'accueil
      </button>

      <div style={{
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '20px',
        padding: '40px',
        marginBottom: '32px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
          <Shield size={40} color="#00d4ff" />
          <h1 style={{ fontSize: 'clamp(32px, 5vw, 48px)', fontWeight: 800, margin: 0 }}>
            Politique de Confidentialité
          </h1>
        </div>

        <div style={{ color: 'rgba(255, 255, 255, 0.8)', lineHeight: 1.8, fontSize: '16px' }}>
          <p style={{ marginBottom: '32px', fontSize: '18px', color: 'rgba(255, 255, 255, 0.7)' }}>
            <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
              1. Introduction
            </h2>
            <p style={{ marginBottom: '16px' }}>
              WorkBiFlow (ci-après "nous", "notre" ou "la Plateforme") s'engage à protéger la confidentialité et la sécurité des données personnelles de ses utilisateurs.
            </p>
            <p>
              La présente Politique de Confidentialité explique comment nous collectons, utilisons, stockons et protégeons vos données personnelles conformément au Règlement Général sur la Protection des Données (RGPD).
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
              2. Données collectées
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Nous collectons les données suivantes :
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}><strong>Données d'identification :</strong> nom, prénom, adresse email, numéro de téléphone</li>
              <li style={{ marginBottom: '8px' }}><strong>Données professionnelles :</strong> fonction, département, date d'embauche</li>
              <li style={{ marginBottom: '8px' }}><strong>Données de pointage :</strong> heures d'arrivée et de départ, géolocalisation, photos</li>
              <li style={{ marginBottom: '8px' }}><strong>Données de navigation :</strong> adresse IP, type de navigateur, pages visitées</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
              3. Utilisation des données
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Vos données personnelles sont utilisées pour :
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Fournir et améliorer les services de la Plateforme</li>
              <li style={{ marginBottom: '8px' }}>Gérer les pointages et les présences</li>
              <li style={{ marginBottom: '8px' }}>Traiter les demandes de congés et les notes de frais</li>
              <li style={{ marginBottom: '8px' }}>Assurer la sécurité et prévenir les fraudes</li>
              <li style={{ marginBottom: '8px' }}>Vous envoyer des notifications et communications importantes</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
              4. Conservation des données
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Vos données personnelles sont conservées pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées, conformément aux obligations légales et réglementaires.
            </p>
            <p>
              Lorsque vous supprimez votre compte, vos données personnelles sont supprimées dans un délai de 30 jours, sauf si la conservation est nécessaire pour respecter nos obligations légales.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
              5. Partage des données
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Nous ne vendons ni ne louons vos données personnelles à des tiers. Nous pouvons partager vos données uniquement dans les cas suivants :
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}>Avec votre consentement explicite</li>
              <li style={{ marginBottom: '8px' }}>Pour respecter une obligation légale</li>
              <li style={{ marginBottom: '8px' }}>Avec nos prestataires de services (hébergeurs, services de paiement) sous contrat de confidentialité</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
              6. Vos droits
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Conformément au RGPD, vous disposez des droits suivants :
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li style={{ marginBottom: '8px' }}><strong>Droit d'accès :</strong> Vous pouvez demander l'accès à vos données personnelles</li>
              <li style={{ marginBottom: '8px' }}><strong>Droit de rectification :</strong> Vous pouvez demander la correction de vos données</li>
              <li style={{ marginBottom: '8px' }}><strong>Droit à l'effacement :</strong> Vous pouvez demander la suppression de vos données</li>
              <li style={{ marginBottom: '8px' }}><strong>Droit à la portabilité :</strong> Vous pouvez demander la récupération de vos données</li>
              <li style={{ marginBottom: '8px' }}><strong>Droit d'opposition :</strong> Vous pouvez vous opposer au traitement de vos données</li>
            </ul>
            <p>
              Pour exercer vos droits, contactez-nous à : <a href="mailto:privacy@workbiflow.com" style={{ color: '#00d4ff', textDecoration: 'underline' }}>privacy@workbiflow.com</a>
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
              7. Sécurité
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, perte, destruction ou altération.
            </p>
            <p>
              Ces mesures incluent notamment le chiffrement des données, la sécurisation des serveurs, et l'accès restreint aux données personnelles.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
              8. Cookies
            </h2>
            <p>
              La Plateforme utilise des cookies pour améliorer l'expérience utilisateur et analyser l'utilisation de la Plateforme. Vous pouvez configurer votre navigateur pour refuser les cookies, mais cela peut affecter certaines fonctionnalités de la Plateforme.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px', color: '#00d4ff' }}>
              9. Contact
            </h2>
            <p style={{ marginBottom: '16px' }}>
              Pour toute question concernant cette Politique de Confidentialité, vous pouvez nous contacter à :
            </p>
            <p>
              <strong>Email :</strong> <a href="mailto:privacy@workbiflow.com" style={{ color: '#00d4ff', textDecoration: 'underline' }}>privacy@workbiflow.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ConfidentialityPage;

